import { ErrorText, HelpTip } from '@dataroom/shared';
import { useNewDocumentAlerts, useSetNewDocumentAlerts } from '@/api/hooks';

/**
 * ADR-0056 — the buyer's own switch for the daily "new documents" email: at most
 * one a day, listing only documents newly available to them. On by default.
 * Hidden when the server offers no switch (a 404 for someone who is not a buyer
 * of this room) or while it loads.
 */
export function NewDocumentAlertsToggle({ roomId }: { roomId: string }) {
  const pref = useNewDocumentAlerts(roomId);
  const save = useSetNewDocumentAlerts(roomId);
  if (!pref.data) return null;
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1">
        <label className="flex w-fit items-center gap-2 text-sm">
          <input
            type="checkbox"
            className="h-4 w-4"
            checked={pref.data.enabled}
            disabled={save.isPending}
            onChange={(e) => save.mutate(e.target.checked)}
          />
          Email me about new documents
        </label>
        <HelpTip id="buyer.documents.new-alerts" />
      </div>
      <p className="pl-6 text-xs text-muted-foreground">
        At most once a day, when documents are added to what you can see.
      </p>
      {save.error ? <ErrorText error={save.error} /> : null}
    </div>
  );
}
